import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InspectionReportContext } from 'stores/InspectionReportStore'
// import { UserContext } from 'stores/UserStore'
import { Modal, Card, FlexView, Icon, Button, LoadingOverlay } from 'components/common'
import { Input } from 'components/form'
import { TextArea } from 'components/form'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'

const InternalApprovalModal = ({ isOpen, onOutsideClick }) => {
  const { t } = useTranslation()
  const history = useHistory()  
  // const { currentUser } = useContext(UserContext)
  const { internalApproveReport } = useContext(InspectionReportContext)
  const [loading, setLoading] = useState(false)
  const [comments, setComments] = useState('')
  const [approvedBy, setApprovedBy] = useState('')

  const onSaveClick = async () => {

    try {
      if (approvedBy && approvedBy.trim().length) {
        setLoading(true)
        await internalApproveReport(comments, approvedBy)
        toast.success(t('inspectionReportApproval.operationSuccess'))
        history.replace('/inspection-report')
        setLoading(false)
        onOutsideClick()
      } else {
        toast.error(t('inspectionReportApproval.approval-required'))
      }
    } catch (error) {
      console.debug(error)
      toast.error(error.errorMessage)
    }    

  }

  const handleApprovedBy = (event) => {
    setApprovedBy(event.target.value)
  }  

  const handleComments = (event) => {
    setComments(event.target.value)
  }  

  return <Modal isOpen={isOpen} onOutsideClick={onOutsideClick}>
    <Card padding="16px" maxWidth="500px" width="80vw">
      <FlexView fontSize="subtitle" fontWeight="bold" flexDirection="row" justifyContent="space-between" alignItems="center" alignSelf="stretch">
        <span>{t('inspectionReportApproval.comments')}</span>
        <Icon name="cross" color="error" width="24px" height="24px" onClick={onOutsideClick} />
      </FlexView>
      <FlexView alignSelf="stretch" margin="8px 0px 0px" height="210px" style={{ overflow: 'auto' }}>
        <TextArea width="100%" rows="8" onChange={handleComments}  ></TextArea>
      </FlexView>
      <FlexView alignSelf="stretch" margin="0px">
        <Input label={t('inspectionReportApproval.appoved-by')} width="100%" margin="0px" value={approvedBy} required onChange={handleApprovedBy}  />
      </FlexView>
      <FlexView flexDirection="row" justifyContent="flex-end" alignItems="center" alignSelf="stretch">
        <Button margin="0px 0px 8px" color="white" backgroundColor="secondary" height="39px" onClick={onSaveClick}>{t('inspectionReportApproval.approve')}</Button>
      </FlexView>
    </Card>
    <LoadingOverlay visible={loading} />
  </Modal>
}

export default InternalApprovalModal
